// frontend_app/src/components/KeywordHighlighter.js
import React, { useMemo } from 'react';

const KEYWORD_RULES = [
  { name: 'EDTA', aliases: ['edta', 'edta whole blood'], className: 'keyword--edta', },
  { name: 'SST', aliases: ['sst', 'serum separating tube', 'serum separator tube'], className: 'keyword--sst', },
  { name: 'Lithium Heparin', aliases: ['lithium heparin', 'lith hep', 'lih'], className: 'keyword--lithium-heparin', },
  { name: 'Urine', aliases: ['urine', 'random urine', '24 hour urine', '24hr urine', 'midstream urine', 'msu'], className: 'keyword--urine', },
  { name: 'Fluoride Oxalate', aliases: ['fluoride oxalate', 'fl oxalate', 'grey top', 'gray top', 'fluoride', 'glucose tube'], className: 'keyword--fluoride-oxalate', },
  { name: 'Citrate', aliases: ['citrate', 'sodium citrate', 'blue top', 'coag tube', 'coagulation'], className: 'keyword--citrate', },
];

const aliasMap = {};
KEYWORD_RULES.forEach(rule => {
  rule.aliases.forEach(alias => {
    aliasMap[alias] = rule.className;
  });
});

const KeywordHighlighter = ({ text, searchTerm, enableSampleHighlighting }) => {
  const regex = useMemo(() => {
    if (!text) return null;
    
    const keywordParts = enableSampleHighlighting ? Object.keys(aliasMap).map(alias => `\\b${alias}\\b`) : [];
    const escapedSearchTerm = searchTerm ? searchTerm.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') : null;
    
    const allRegexParts = [...keywordParts];
    if (escapedSearchTerm) {
        allRegexParts.push(escapedSearchTerm);
    }
    
    if (allRegexParts.length === 0) return null;
    
    return new RegExp(`(${allRegexParts.join('|')})`, 'gi');
  }, [text, searchTerm, enableSampleHighlighting]);

  if (!regex || !text) {
    return <>{text || ''}</>;
  }

  const parts = text.split(regex);

  return (
    <>
      {parts.map((part, index) => {
        if (!part) return null;
        const lowerCasePart = part.toLowerCase();
        
        // Check search term match first (case-insensitive comparison)
        if (searchTerm && lowerCasePart === searchTerm.toLowerCase()) {
          return <mark key={index} className="highlight">{part}</mark>;
        }
        
        // Check sample keyword match
        if (enableSampleHighlighting && aliasMap[lowerCasePart]) {
          const className = aliasMap[lowerCasePart];
          return (
            <span key={index} className={`keyword-highlight ${className}`}>
              {part}
            </span>
          );
        }
        
        return part;
      })}
    </>
  );
};

export default KeywordHighlighter;